/**
 * @fileoverview ランキング用の集計期間表示コンポーネント
 */
<script lang="ts">
import { defineComponent } from 'vue'
import { localeDateJa } from '@/utilities/formatter'

export default defineComponent({
  name: 'RankingPeriod',

  props: {
    heading: {
      type: String,
      default: '集計期間',
    },

    from: {
      type: String,
      default: '',
    },

    to: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      // methods
      localeDateJa,
    }
  }
})
</script>

<template>
  <div
    v-if="from || to"
    class="o-label__period">
    <dl class="o-label__period--unit">
      <dt
        v-if="heading"
        class="o-label__period--term">
        {{ heading }}
      </dt>
      <dd class="o-label__period--description is-from">
        <time
          class="time"
          :datetime="from">
          {{ localeDateJa(from) }}
        </time>
      </dd>
      <dd class="o-label__period--description is-to">
        <time
          class="time"
          :datetime="to">
          {{ localeDateJa(to) }}
        </time>
      </dd>
    </dl>
  <!-- /.o-label__period --></div>
</template>

<style lang="sass" scoped>
.o-label__period
  & &--unit
    display: flex
    align-items: center
    line-height: 1
    color: $font-gray
    font:
      size: $font-x-small
      weight: normal

  & &--term
    &::after
      content: "："

  $hyphen-size: 1em
  $hyphen-margin: 0.2em
  & &--description
    &.is-to
      display: flex
      align-items: center
      position: relative
      margin-left: $hyphen-margin
      padding-left: $hyphen-size + $hyphen-margin

      &::before
        content: "-"
        width: $hyphen-size
        display: inline-block
        text-align: center
        vertical-align: baseline
        margin:
          left: -#{$hyphen-size + $hyphen-margin}
          right: $hyphen-margin
</style>
